<template>
  <div class="text-center">
    <h1>REEM</h1>
    <div class="mb-5">
      <vs-button @click="showData('allReem')" color="#95a5a6" size="large" class=" text-white font-bold"
        style="height: 70px;">
        {{ reemTotal }}</vs-button>
      &nbsp;&nbsp;
      <vs-button @click="showData('Reemgr')" color="#2ecc71" size="large" class=" text-white font-bold"
        style="height: 70px;">{{ reemgrCount }}
      </vs-button>
      &nbsp;&nbsp;
      <vs-button @click="showData('Reemgs')" color="#3498db" size="large" class=" text-white font-bold"
        style="height: 70px;">{{ reemgsCount
        }}</vs-button>
    </div>
    <vs-row vs-w="12" vs-type="flex" vs-justify="center">
      <vs-col vs-lg="12" vs-sm="12" vs-xs="12" vs-type="flex" vs-justify="center" vs-align="center">
        <donutHandler :dasbhboardData="reemData"></donutHandler>
      </vs-col>
    </vs-row>
  </div>
</template>
<script>
import StatisticsCardLine from '@/components/statistics-cards/StatisticsCardLine.vue'
import { axiosMixin } from '../../mixin/axiosMixin';
import donutHandler from './donutHandler.vue'
export default {
  mixins: [axiosMixin],
  components: {
    StatisticsCardLine,
    donutHandler
  },
  props: {
    reemTotal: {
      type: [Number, String],
      default: "",
    },
    reemgrCount: {
      type: [Number, String],
      default: "",
    },
    reemgsCount: {
      type: [Number, String],
      default: "",
    }, reemData: {
      type: Object,
      default: () => { }
    }
  },
  data() {
    return {
    };
  },
  methods: {
    showData(subject) {
      this.$emit("showData", subject);
    },
    startLoading() {
      this.$vs.loading({
        container: '#container',
        scale: 0.6
      });
    },
    stopLoading() {
      this.$vs.loading.close('#container > .con-vs-loading');
    },
    getData() {
      this.startLoading();
      this.aronPost('getData', {}, '', '')
        .then(response => {
          if (response.status) {
          } else {
            this.errorAlert('Error', response.data.error)
          }

          this.stopLoading();
        })
        .catch(error => {
          console.log('error:', error);
          this.stopLoading();
        })

    }

  },
  mounted() {
    // this.getData();
  },
  created() {

  }
};
</script>
